export default __webpack_public_path__ + "static/media/ustur_dark.f413a25e.svg";